import { createAction } from 'redux-actions'

const SET_TOTAL_PRICE = 'SET_TOTAL_PRICE'
const setTotalPrice = createAction(SET_TOTAL_PRICE)

function totalPrice(state = {}, { type, payload }) {
  switch (type) {
    case SET_TOTAL_PRICE:
      return payload
    default:
      return state
  }
}

export {
  setTotalPrice,
  totalPrice,
}
